import apiClient from "./axios";

/**
 * Agent变体路由规则相关API
 * 遵循API_GUIDELINES.md中的标准CRUD函数签名规范
 */
const agentVariantApi = {
    /**
     * 获取Agent变体路由规则列表 - 标准CRUD命名
     * @param {Object} params - 请求参数 (应包含 page 和 page_size)
     * @returns {Promise<Array>} 规则列表
     */
    getList: (params = {}) => apiClient.get("/v1/agent-variant-rules", { params }),

    /**
     * 获取单个Agent变体路由规则 - 标准CRUD命名
     * @param {number} id - 规则ID
     * @returns {Promise<Object>} 规则详情
     */
    getById: (id) => apiClient.get(`/v1/agent-variant-rules/${id}`),

    /**
     * 创建Agent变体路由规则 - 标准CRUD命名
     * @param {Object} data - 规则数据
     * @returns {Promise<Object>} 创建结果
     */
    create: (data) => apiClient.post("/v1/agent-variant-rules", data),

    /**
     * 更新Agent变体路由规则 - 标准CRUD命名，必须使用对象参数
     * @param {Object} params - 包含id和data的对象参数
     * @returns {Promise<Object>} 更新结果
     */
    update: ({ id, data }) => apiClient.put(`/v1/agent-variant-rules/${id}`, data),

    /**
     * 删除Agent变体路由规则 - 标准CRUD命名
     * @param {number} id - 规则ID
     * @returns {Promise<Object>} 删除结果
     */
    delete: (id) => apiClient.delete(`/v1/agent-variant-rules/${id}`),

    /**
     * 获取所有本地Agent名称 - 自定义方法
     * 注意：这是 FlyMeta 本地代码中的 Agent 标识，如 ocr_agent, catering_agent
     * @returns {Promise<Array>} 本地Agent名称列表
     */
    getLocalAgentNames: () => apiClient.get("/v1/agent-variant-rules/local-agent-names"),

    /**
     * 获取所有目标Agent编码 - 自定义方法
     * 注意：这是 Spidermind 平台中的 Agent 名称，如 "Mistral OCR Agent", "应付发票结构化Agent_WS"
     * 与 FlyMeta 本地的 agent_name 不同
     * @returns {Promise<Array>} 目标Agent编码列表
     */
    getTargetAgentCodes: () => apiClient.get("/v1/agent-variant-rules/target-agent-codes"),
};

export { agentVariantApi };
